import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const pesquisa = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('traducoes/pesquisa',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.PESQUISA_TRADUCAO);
            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const novoatualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('traducoes/novoatualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.TRADUCAONOVOATUALIZA);

        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}